import React, { useState } from 'react';
import axiosLib from 'axios';
const axios = axiosLib.create();

const PRESETS = [
  {
    name: 'Sistem Sağlığı (Health)',
    method: 'GET',
    endpoint: '/api/health',
    body: '',
    description: 'Sistem durumunu ve sunucu saatini kontrol eder.'
  },
  {
    name: 'Müşterileri Listele',
    method: 'GET',
    endpoint: '/api/customers',
    body: '',
    description: 'Kayıtlı tüm müşterileri çeker. (X-API-Key gerektirir)'
  },
  {
    name: 'Randevuları Listele',
    method: 'GET',
    endpoint: '/api/appointments',
    body: '',
    description: 'Randevu geçmişini listeler. (X-API-Key gerektirir)'
  },
  {
    name: 'Yeni Müşteri Ekle',
    method: 'POST',
    endpoint: '/api/customers',
    body: JSON.stringify({
      first_name: "Test",
      last_name: "Kullanıcı",
      email: "testapi@ticiplus.com",
      phone: "+905554443322",
      notes: "API test aracılığıyla oluşturuldu"
    }, null, 2),
    description: 'Sisteme yeni bir müşteri kaydı ekler. (X-API-Key gerektirir)'
  },
  {
    name: 'AI Ayarlarını Getir',
    method: 'GET',
    endpoint: '/api/ai/settings',
    body: '',
    description: 'Şubenin yapay zeka ayarlarını çeker. (X-API-Key gerektirir)'
  }
];

const SCAN_ENDPOINTS = [
  { name: 'Sistem Sağlık Durumu', method: 'GET', endpoint: '/api/health', authRequired: false },
  { name: 'Sektör Listesi', method: 'GET', endpoint: '/api/auth/industries', authRequired: false },
  { name: 'Müşteri Listesi', method: 'GET', endpoint: '/api/customers', authRequired: true },
  { name: 'Randevu Listesi', method: 'GET', endpoint: '/api/appointments', authRequired: true },
  { name: 'Şube Listesi', method: 'GET', endpoint: '/api/branches', authRequired: true },
  { name: 'Hizmetler ve Servisler', method: 'GET', endpoint: '/api/services', authRequired: true },
  { name: 'AI Yapay Zeka Ayarları', method: 'GET', endpoint: '/api/ai/settings', authRequired: true }
];

function ApiTesterTab() {
  const [method, setMethod] = useState('GET');
  const [endpoint, setEndpoint] = useState('/api/health');
  const [apiKey, setApiKey] = useState('tcp_6face9a76f270881cdd4ad772f347e0367c7b43776b229e9');
  const [requestBody, setRequestBody] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [responseTime, setResponseTime] = useState(null);

  // Bulk Scan States
  const [scanResults, setScanResults] = useState([]);
  const [scanning, setScanning] = useState(false);
  const [scanReport, setScanReport] = useState('');

  // End-to-End Integration States
  const [integrationResults, setIntegrationResults] = useState([]);
  const [testingIntegration, setTestingIntegration] = useState(false);
  const [integrationReport, setIntegrationReport] = useState('');

  const applyPreset = (preset) => {
    setMethod(preset.method);
    setEndpoint(preset.endpoint);
    setRequestBody(preset.body || '');
  };

  const handleSend = async () => {
    setLoading(true);
    setResponse(null);
    setResponseTime(null);
    const startTime = Date.now();

    try {
      const headers = {};
      if (apiKey.trim()) {
        headers['X-API-Key'] = apiKey.trim();
      }

      let parsedBody = null;
      if (['POST', 'PUT', 'PATCH'].includes(method) && requestBody.trim()) {
        try {
          parsedBody = JSON.parse(requestBody);
        } catch (e) {
          setResponse({
            status: 'JSON_ERROR',
            statusText: 'İstek Gövdesi Geçersiz JSON',
            data: { error: 'Girdiğiniz veri geçerli bir JSON objesi değil. Lütfen formatı düzeltin.' }
          });
          setLoading(false);
          return;
        }
      }

      const config = {
        method,
        url: endpoint,
        headers,
        data: parsedBody,
        validateStatus: () => true
      };

      const res = await axios(config);
      const endTime = Date.now();

      setResponse(res);
      setResponseTime(endTime - startTime);
    } catch (err) {
      const endTime = Date.now();
      setResponse({
        status: 'NETWORK_ERROR',
        statusText: 'İstek Gönderilemedi',
        data: { error: err.message || 'Bilinmeyen ağ hatası.' }
      });
      setResponseTime(endTime - startTime);
    } finally {
      setLoading(false);
    }
  };

  const runBulkScan = async () => {
    setScanning(true);
    setScanResults([]);
    setScanReport('');
    const results = [];
    let reportText = `=== TİCİPLUS CRM API BULK SAĞLIK TARAMASI RAPORU ===\nTarih: ${new Date().toLocaleString('tr-TR')}\nAPI Key: ${apiKey || 'Tanımlı Değil'}\n\n`;

    const headers = {};
    if (apiKey.trim()) {
      headers['X-API-Key'] = apiKey.trim();
    }

    for (const target of SCAN_ENDPOINTS) {
      const startTime = Date.now();
      const currentResult = { name: target.name, method: target.method, endpoint: target.endpoint, status: 'loading', time: 0, response: '' };

      results.push(currentResult);
      setScanResults([...results]);

      try {
        const res = await axios({
          method: target.method,
          url: target.endpoint,
          headers,
          validateStatus: () => true
        });
        const elapsed = Date.now() - startTime;

        currentResult.status = res.status;
        currentResult.time = elapsed;
        currentResult.response = JSON.stringify(res.data).substring(0, 150) + (JSON.stringify(res.data).length > 150 ? '...' : '');

        reportText += `[${res.status >= 200 && res.status < 300 ? 'SUCCESS' : 'FAILED'}] ${target.method} ${target.endpoint}\n`;
        reportText += `   - Durum Kodu: ${res.status}\n`;
        reportText += `   - İstek Süresi: ${elapsed} ms\n`;
        reportText += `   - Sunucu Yanıtı: ${JSON.stringify(res.data).substring(0, 100)}\n\n`;
      } catch (err) {
        const elapsed = Date.now() - startTime;
        currentResult.status = 'ERROR';
        currentResult.time = elapsed;
        currentResult.response = err.message || 'Ağ Hatası';

        reportText += `[ERROR] ${target.method} ${target.endpoint}\n`;
        reportText += `   - Hata: ${err.message}\n`;
        reportText += `   - İstek Süresi: ${elapsed} ms\n\n`;
      }

      setScanResults([...results]);
    }

    setScanReport(reportText);
    setScanning(false);
  };

  const copyReportToClipboard = () => {
    navigator.clipboard.writeText(scanReport);
    alert('📋 API Tarama Raporu panoya kopyalandı! Doğrudan sohbete yapıştırabilirsiniz.');
  };

  // Uçtan Uca Entegrasyon Test Suite
  const runE2EIntegrationTest = async () => {
    setTestingIntegration(true);
    setIntegrationResults([]);
    setIntegrationReport('');
    const results = [];
    let reportText = `=== TİCİPLUS CRM UÇTAN UCA ENTEGRASYON (CRUD) TEST RAPORU ===\nTarih: ${new Date().toLocaleString('tr-TR')}\nAPI Key: ${apiKey || 'Tanımlı Değil'}\n\n`;

    const headers = {};
    if (apiKey.trim()) {
      headers['X-API-Key'] = apiKey.trim();
    }

    let testCustomerId = null;
    let testAppointmentId = null;

    const steps = [
      // Step 1: Health & Industries Read
      {
        name: 'Aşama 1: Sistem Hazırlık Kontrolleri',
        run: async () => {
          const res1 = await axios.get('/api/health', { headers, validateStatus: () => true });
          const res2 = await axios.get('/api/auth/industries', { headers, validateStatus: () => true });
          return {
            success: res1.status === 200 && res2.status === 200,
            status: `${res1.status} & ${res2.status}`,
            msg: `Sistem durum bilgisi alındı, aktif sektör sayısı: ${res2.data.length || 0}`
          };
        }
      },
      // Step 2: Create Customer (POST)
      {
        name: 'Aşama 2: Yeni Müşteri Kaydı Oluşturma (POST)',
        run: async () => {
          const payload = {
            first_name: "E2E Entegrasyon",
            last_name: "Testi",
            email: "e2etest_" + Math.floor(Math.random() * 100000) + "@ticiplus.com",
            phone: "+905001112233",
            notes: "Otomatik entegrasyon test kaydıdır."
          };
          const res = await axios.post('/api/customers', payload, { headers, validateStatus: () => true });

          if (res.status === 201 || res.status === 200) {
            // Müşteri ID'sini bul (Dönen objeden ya da listelemeden)
            testCustomerId = res.data.id || (res.data.data ? res.data.data.id : null);

            // Eğer id doğrudan gelmediyse müşteriler listesinden en son ekleneni bulmaya çalış
            if (!testCustomerId) {
              const listRes = await axios.get('/api/customers?limit=1', { headers });
              if (listRes.data && listRes.data.data && listRes.data.data.length > 0) {
                testCustomerId = listRes.data.data[0].id;
              }
            }

            return {
              success: !!testCustomerId,
              status: res.status,
              msg: `Müşteri başarıyla oluşturuldu. ID: ${testCustomerId || 'Bilinmiyor'}`
            };
          }
          return { success: false, status: res.status, msg: `Müşteri ekleme başarısız: ` + JSON.stringify(res.data) };
        }
      },
      // Step 3: Update Customer (PUT)
      {
        name: 'Aşama 3: Müşteri Bilgisi Güncelleme (PUT)',
        run: async () => {
          if (!testCustomerId) return { success: false, status: 'SKIP', msg: 'Müşteri ID bulunamadığı için atlandı.' };
          const payload = {
            first_name: "E2E Entegrasyon",
            last_name: "Güncellendi",
            phone: "+905009998877",
            notes: "Müşteri bilgileri başarıyla güncellendi."
          };
          const res = await axios.put(`/api/customers/${testCustomerId}`, payload, { headers, validateStatus: () => true });
          return {
            success: res.status === 200,
            status: res.status,
            msg: res.status === 200 ? 'Müşteri başarıyla güncellendi.' : 'Güncelleme hatası: ' + JSON.stringify(res.data)
          };
        }
      },
      // Step 4: Add Measurement (POST)
      {
        name: 'Aşama 4: Müşteriye Özel Ölçüm Kaydı Girişi (POST)',
        run: async () => {
          if (!testCustomerId) return { success: false, status: 'SKIP', msg: 'Müşteri ID bulunamadığı için atlandı.' };
          const payload = {
            chest: 95,
            waist: 75,
            hips: 100,
            height: 175,
            weight: 65,
            notes: "E2E Entegrasyon test ölçüm bilgisi"
          };
          const res = await axios.post(`/api/customers/${testCustomerId}/measurements`, payload, { headers, validateStatus: () => true });
          return {
            success: res.status === 201 || res.status === 200,
            status: res.status,
            msg: (res.status === 201 || res.status === 200) ? 'Ölçüm bilgisi eklendi.' : 'Ölçüm ekleme hatası: ' + JSON.stringify(res.data)
          };
        }
      },
      // Step 5: Create Appointment (POST)
      {
        name: 'Aşama 5: Randevu Oluşturma (POST)',
        run: async () => {
          if (!testCustomerId) return { success: false, status: 'SKIP', msg: 'Müşteri ID bulunamadığı için atlandı.' };

          // Sistemde tanımlı ilk hizmet ve personeli dinamik al
          const branchRes = await axios.get('/api/branches', { headers, validateStatus: () => true });
          const branchId = (branchRes.data && branchRes.data.length > 0) ? branchRes.data[0].id : 1;

          const serviceRes = await axios.get('/api/services', { headers, validateStatus: () => true });
          const serviceId = (serviceRes.data && serviceRes.data.length > 0) ? serviceRes.data[0].id : 1;

          const staffRes = await axios.get('/api/staff', { headers, validateStatus: () => true });
          const staffId = (staffRes.data && staffRes.data.length > 0) ? staffRes.data[0].id : 1;

          const tomorrow = new Date();
          tomorrow.setDate(tomorrow.getDate() + 1);
          const tomorrowDateStr = tomorrow.toISOString().split('T')[0];

          const payload = {
            customer_id: testCustomerId,
            branch_id: branchId,
            service_id: serviceId,
            staff_id: staffId,
            scheduled_at: `${tomorrowDateStr} 14:00:00`,
            notes: "E2E Entegrasyon Test Randevusu",
            source: "api"
          };

          const res = await axios.post('/api/appointments', payload, { headers, validateStatus: () => true });
          if (res.status === 201 || res.status === 200) {
            testAppointmentId = res.data.id || (res.data.data ? res.data.data.id : null);
            if (!testAppointmentId) {
              const appList = await axios.get('/api/appointments', { headers });
              if (appList.data && appList.data.length > 0) {
                testAppointmentId = appList.data[0].id;
              }
            }
            return {
              success: !!testAppointmentId,
              status: res.status,
              msg: `Randevu başarıyla oluşturuldu. ID: ${testAppointmentId || 'Bilinmiyor'}`
            };
          }
          return { success: false, status: res.status, msg: `Randevu oluşturma hatası: ` + JSON.stringify(res.data) };
        }
      },
      // Step 6: Update Appointment Status (PUT)
      {
        name: 'Aşama 6: Randevu Durumu Değişikliği (PUT)',
        run: async () => {
          if (!testAppointmentId) return { success: false, status: 'SKIP', msg: 'Randevu ID bulunamadığı için atlandı.' };
          const payload = { status: 'completed' };
          const res = await axios.put(`/api/appointments/${testAppointmentId}/status`, payload, { headers, validateStatus: () => true });
          return {
            success: res.status === 200,
            status: res.status,
            msg: res.status === 200 ? 'Randevu başarıyla tamamlandı (completed) durumuna alındı.' : 'Randevu durumu güncellenemedi.'
          };
        }
      },
      // Step 7: Create Payment (POST)
      {
        name: 'Aşama 7: Muhasebe & Tahsilat Girişi (POST)',
        run: async () => {
          if (!testCustomerId) return { success: false, status: 'SKIP', msg: 'Müşteri bulunamadığı için atlandı.' };
          const payload = {
            customer_id: testCustomerId,
            appointment_id: testAppointmentId || null,
            total_amount: 750.00,
            payment_methods: ['credit_card'],
            notes: "E2E Entegrasyon Muhasebe Test Tahsilatı"
          };
          const res = await axios.post('/api/payments', payload, { headers, validateStatus: () => true });
          return {
            success: res.status === 201 || res.status === 200,
            status: res.status,
            msg: (res.status === 201 || res.status === 200) ? 'Tahsilat kaydı oluşturuldu.' : 'Muhasebe girişi hatası: ' + JSON.stringify(res.data)
          };
        }
      },
      // Step 8: Read and Update AI Settings (GET & PUT)
      {
        name: 'Aşama 8: AI Yapay Zeka Ayarları Güncelleme (PUT)',
        run: async () => {
          // NOT: Bu test CANLI ayarlar üzerinde çalışır. Bu yüzden system_prompt'a
          // ASLA dokunulmaz — eskiden prompta boşluk ekliyor, prompt boşsa yerine
          // "Sen bir CRM asistanısı..." yazıyordu ve müşterinin promptunu bozuyordu.
          // Artık yalnızca zararsız bir alan (max_history) aynı değeriyle yazılıp
          // PUT yolunun çalıştığı doğrulanır.
          const getRes = await axios.get('/api/ai/settings', { headers });
          if (getRes.status === 200) {
            const currentSettings = getRes.data || {};
            const payload = { max_history: currentSettings.max_history || 20 };
            const updateRes = await axios.put('/api/ai/settings', payload, { headers, validateStatus: () => true });

            // Doğrulama: prompt testten etkilenmemiş olmalı
            const verifyRes = await axios.get('/api/ai/settings', { headers, validateStatus: () => true });
            const promptIntact = verifyRes.status !== 200
              || (verifyRes.data?.system_prompt || '') === (currentSettings.system_prompt || '');

            return {
              success: updateRes.status === 200 && promptIntact,
              status: updateRes.status,
              msg: updateRes.status !== 200
                ? 'AI Güncelleme hatası: ' + JSON.stringify(updateRes.data)
                : (promptIntact
                    ? 'Yapay zeka ayar güncelleme yolu doğrulandı (prompt değiştirilmedi).'
                    : 'UYARI: PUT isteği promptu değiştirdi — kısmi güncelleme çalışmıyor!')
            };
          }
          return { success: false, status: getRes.status, msg: 'AI ayarları alınamadığı için güncelleme yapılamadı.' };
        }
      },
      // Aşama 9: Ürün ve Stok Yönetimi (POST)
      {
        name: 'Aşama 9: Ürün/Stok Ekleme (POST)',
        run: async () => {
          const payload = {
            name: 'API Test Ürünü ' + Math.floor(Math.random() * 1000),
            sku: 'TEST-SKU-' + Math.floor(Math.random() * 1000),
            sale_price: 250.00,
            cost_price: 100.00,
            stock_quantity: 50
          };
          const res = await axios.post('/api/products', payload, { headers, validateStatus: () => true });
          return {
            success: res.status === 200 || res.status === 201,
            status: res.status,
            msg: (res.status === 200 || res.status === 201) ? 'Stok ürünü başarıyla oluşturuldu.' : 'Ürün ekleme hatası: ' + JSON.stringify(res.data)
          };
        }
      },
      // Aşama 10: CallOps Modülü
      {
        name: 'Aşama 10: CallOps Çağrı Merkezi Verisi (GET)',
        run: async () => {
          const res = await axios.get('/api/callops/calls', { headers, validateStatus: () => true });
          return { success: res.status === 200, status: res.status, msg: res.status === 200 ? 'CallOps çağrı verileri başarıyla çekildi.' : 'CallOps hatası.' };
        }
      },
      // Aşama 11: Ticari Modül - Teklifler
      {
        name: 'Aşama 11: Ticari Modül - Teklif Yönetimi (GET)',
        run: async () => {
          const res = await axios.get('/api/quotes', { headers, validateStatus: () => true });
          return { success: res.status === 200, status: res.status, msg: res.status === 200 ? 'Ticari teklifler başarıyla okundu.' : 'Ticari modül hatası.' };
        }
      },
      // Aşama 12: Sağlık Turizmi ve Klinik
      {
        name: 'Aşama 12: Sağlık Turizmi - Klinik Kayıtları (GET)',
        run: async () => {
          const res = await axios.get('/api/clinic-records', { headers, validateStatus: () => true });
          if (res.status === 500) return { success: false, status: 'SKIP', msg: 'Klinik tabloları mevcut değil (Bu sektör için aktif değil).' };
          return { success: res.status === 200, status: res.status, msg: res.status === 200 ? 'Klinik kayıtları başarıyla okundu.' : 'Klinik modülü hatası.' };
        }
      },
      // Aşama 13: Düğün ve Etkinlik
      {
        name: 'Aşama 13: Etkinlik & Düğün Sözleşmeleri (GET)',
        run: async () => {
          const res = await axios.get('/api/wedding-contracts', { headers, validateStatus: () => true });
          if (res.status === 500) return { success: false, status: 'SKIP', msg: 'Düğün tabloları mevcut değil (Bu sektör için aktif değil).' };
          return { success: res.status === 200, status: res.status, msg: res.status === 200 ? 'Etkinlik sözleşmeleri başarıyla okundu.' : 'Düğün modülü hatası.' };
        }
      },
      // Aşama 14: E-Ticaret ve Otel Rezervasyonları
      {
        name: 'Aşama 14: E-Ticaret ve Otel Verileri (GET)',
        run: async () => {
          const res = await axios.get('/api/ecommerce-products', { headers, validateStatus: () => true });
          if (res.status === 500) return { success: false, status: 'SKIP', msg: 'Ticari/Otel tabloları mevcut değil (Bu sektör için aktif değil).' };
          return { success: res.status === 200, status: res.status, msg: res.status === 200 ? 'E-ticaret ürün kataloğu okundu.' : 'Otel/Eticaret modülü hatası.' };
        }
      }
    ];

    for (const step of steps) {
      const startTime = Date.now();
      const currentResult = { name: step.name, status: 'loading', time: 0, msg: '' };

      results.push(currentResult);
      setIntegrationResults([...results]);

      const stepOut = await step.run();
      const elapsed = Date.now() - startTime;

      currentResult.status = stepOut.success ? 'SUCCESS' : (stepOut.status === 'SKIP' ? 'SKIP' : 'FAILED');
      currentResult.time = elapsed;
      currentResult.msg = stepOut.msg;

      reportText += `[${currentResult.status}] ${step.name}\n`;
      reportText += `   - İstek Süresi: ${elapsed} ms\n`;
      reportText += `   - Durum Kodu: ${stepOut.status}\n`;
      reportText += `   - Detay: ${stepOut.msg}\n\n`;

      setIntegrationResults([...results]);
    }

    reportText += `\n=== ENTEGRASYON TESTİ SONUCU ===\n`;
    const failedSteps = results.filter(r => r.status === 'FAILED');
    if (failedSteps.length === 0) {
      reportText += `✅ TÜM API ÖZELLİKLERİ VE VERİ TABANI YAZMA İŞLEMLERİ BAŞARIYLA TAMAMLANDI!\n`;
    } else {
      reportText += `❌ BAŞARISIZ OLAN AŞAMALAR MEVCUT. Hata sayısı: ${failedSteps.length}\n`;
    }

    setIntegrationReport(reportText);
    setTestingIntegration(false);
  };

  const copyIntegrationReport = () => {
    navigator.clipboard.writeText(integrationReport);
    alert('📋 Uçtan Uca Entegrasyon Test Raporu panoya kopyalandı! Doğrudan sohbete yapıştırabilirsiniz.');
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>

      {/* ÜST PANEL 1: Tek Tıkla Uçtan Uca (E2E) CRUD Entegrasyon Testi */}
      <div style={{ background: 'rgba(17,17,24,0.7)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '14px', padding: '20px', backdropFilter: 'blur(12px)', borderLeft: '4px solid #10B981' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginBottom: '16px' }}>
          <div style={{ flex: 1 }}>
            <h4 style={{ margin: 0, color: '#FFFFFF', fontSize: '15px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>🎯 Uçtan Uca Entegrasyon ve CRUD Özellikleri Testi (Önerilen)</span>
            </h4>
            <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#9CA3AF' }}>
              Sadece okuma yapmaz. Sistemde müşteri kaydeder (POST), düzenler (PUT), ölçüm ekler, randevu oluşturur, durum günceller, muhasebe girişi yapar ve AI ayarlarını kaydeder.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={runE2EIntegrationTest}
              disabled={testingIntegration}
              style={{
                padding: '10px 20px',
                background: testingIntegration ? 'rgba(16,185,129,0.2)' : 'linear-gradient(135deg, #10B981, #059669)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '8px',
                fontWeight: 'bold',
                cursor: testingIntegration ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                boxShadow: '0 4px 12px rgba(16,185,129,0.3)'
              }}
            >
              {testingIntegration ? '⏳ Entegrasyon Test Ediliyor...' : '🚀 Tüm API Özelliklerini Test Et'}
            </button>
            {integrationReport && (
              <button
                onClick={copyIntegrationReport}
                style={{
                  padding: '10px 20px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  color: '#34D399',
                  cursor: 'pointer',
                  fontWeight: '600',
                  transition: 'all 0.2s'
                }}
              >
                📋 Entegrasyon Raporunu Kopyala
              </button>
            )}
          </div>
        </div>

        {/* E2E Entegrasyon Sonuç Kartları */}
        {integrationResults.length > 0 && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '16px', borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '16px' }}>
            {integrationResults.map((res, index) => {
              const isSuccess = res.status === 'SUCCESS';
              const isSkip = res.status === 'SKIP';
              const isLoading = res.status === 'loading';
              return (
                <div key={index} style={{
                  background: 'rgba(26,26,36,0.5)',
                  border: isLoading ? '1px solid rgba(59,130,246,0.3)' : (isSuccess ? '1px solid rgba(16,185,129,0.25)' : (isSkip ? '1px solid rgba(245,158,11,0.25)' : '1px solid rgba(239,68,68,0.25)')),
                  borderRadius: '8px',
                  padding: '12px 16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px'
                }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flex: 1, minWidth: 0 }}>
                    <span style={{ fontSize: '16px' }}>
                      {isLoading ? '🔵' : (isSuccess ? '🟢' : (isSkip ? '🟡' : '🔴'))}
                    </span>
                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0 }}>
                      <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#FFFFFF' }}>{res.name}</span>
                      <span style={{ fontSize: '11px', color: '#9CA3AF', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{res.msg}</span>
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flexShrink: 0 }}>
                    <span style={{ fontFamily: 'monospace', fontSize: '11px', color: '#6B7280' }}>⏱️ {res.time} ms</span>
                    <span style={{
                      fontSize: '11px',
                      fontWeight: 'bold',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      background: isLoading ? 'rgba(59,130,246,0.12)' : (isSuccess ? 'rgba(16,185,129,0.12)' : (isSkip ? 'rgba(245,158,11,0.12)' : 'rgba(239,68,68,0.12)')),
                      color: isLoading ? '#60A5FA' : (isSuccess ? '#34D399' : (isSkip ? '#F59E0B' : '#FCA5A5'))
                    }}>
                      {isLoading ? 'Çalışıyor...' : res.status}
                    </span>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ÜST PANEL 2: Basit Uç Noktası Sağlık Taraması */}
      <div style={{ background: 'rgba(17,17,24,0.7)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '14px', padding: '20px', backdropFilter: 'blur(12px)' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: '16px', marginBottom: '16px' }}>
          <div style={{ flex: 1 }}>
            <h4 style={{ margin: 0, color: '#FFFFFF', fontSize: '15px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
              <span>🔍 Hızlı Uç Noktası Bağlantı Taraması</span>
            </h4>
            <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#9CA3AF' }}>
              Temel veritabanı tablolarının ve sunucu bağlantısının aktiflik/erişim durumunu hızlıca listeler.
            </p>
          </div>
          <div style={{ display: 'flex', gap: '10px' }}>
            <button
              onClick={runBulkScan}
              disabled={scanning}
              style={{
                padding: '10px 20px',
                background: scanning ? 'rgba(59,130,246,0.2)' : 'linear-gradient(135deg, #3B82F6, #2563EB)',
                color: '#FFFFFF',
                border: 'none',
                borderRadius: '8px',
                fontWeight: 'bold',
                cursor: scanning ? 'not-allowed' : 'pointer',
                transition: 'all 0.2s',
                boxShadow: '0 4px 12px rgba(59,130,246,0.3)'
              }}
            >
              {scanning ? '⏳ API Taranıyor...' : '🔍 Hızlı Taramayı Başlat'}
            </button>
            {scanReport && (
              <button
                onClick={copyReportToClipboard}
                style={{
                  padding: '10px 20px',
                  background: 'rgba(255,255,255,0.06)',
                  border: '1px solid rgba(255,255,255,0.1)',
                  borderRadius: '8px',
                  color: '#60A5FA',
                  cursor: 'pointer',
                  fontWeight: '600',
                  transition: 'all 0.2s'
                }}
              >
                📋 Raporu Kopyala
              </button>
            )}
          </div>
        </div>

        {/* Canlı Tarama Sonuçları Listesi */}
        {scanResults.length > 0 && (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '10px', marginTop: '16px', borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '16px' }}>
            {scanResults.map((res, index) => {
              const isSuccess = res.status >= 200 && res.status < 300;
              const isLoading = res.status === 'loading';
              return (
                <div key={index} style={{
                  background: 'rgba(26,26,36,0.5)',
                  border: isLoading ? '1px solid rgba(59,130,246,0.3)' : (isSuccess ? '1px solid rgba(16,185,129,0.25)' : '1px solid rgba(239,68,68,0.25)'),
                  borderRadius: '10px',
                  padding: '12px',
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '6px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <span style={{ fontSize: '13px', fontWeight: 'bold', color: '#FFFFFF' }}>{res.name}</span>
                    <span style={{
                      fontSize: '11px',
                      fontWeight: 'bold',
                      padding: '2px 8px',
                      borderRadius: '4px',
                      background: isLoading ? 'rgba(59,130,246,0.12)' : (isSuccess ? 'rgba(16,185,129,0.12)' : 'rgba(239,68,68,0.12)'),
                      color: isLoading ? '#60A5FA' : (isSuccess ? '#34D399' : '#FCA5A5')
                    }}>
                      {isLoading ? 'Yükleniyor...' : res.status}
                    </span>
                  </div>
                  <div style={{ fontFamily: 'monospace', fontSize: '11px', color: '#9CA3AF', display: 'flex', gap: '8px' }}>
                    <span style={{ color: '#F59E0B', fontWeight: 'bold' }}>{res.method}</span>
                    <span>{res.endpoint}</span>
                  </div>
                  {!isLoading && (
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: '11px', color: '#6B7280', borderTop: '1px solid rgba(255,255,255,0.03)', paddingTop: '6px', marginTop: '2px' }}>
                      <span>⏱️ {res.time} ms</span>
                      <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', maxWidth: '160px', color: isSuccess ? '#A7F3D0' : '#FECACA' }} title={res.response}>
                        {res.response}
                      </span>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>

      {/* ALT PANEL: İstek Sihirbazı & Manuel Arayüz */}
      <div style={{ display: 'flex', gap: '20px', alignItems: 'stretch' }}>
        {/* SOL TARAF: İstek Editörü */}
        <div style={{ flex: 1, background: 'rgba(17,17,24,0.6)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '14px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <h4 style={{ margin: 0, color: '#FFFFFF', fontSize: '15px', fontWeight: 600, display: 'flex', alignItems: 'center', gap: '8px' }}>
            <span>🧪 İstek Özelleştirme Sihirbazı</span>
          </h4>

          {/* Hazır Şablonlar */}
          <div>
            <label style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: 500, display: 'block', marginBottom: '8px' }}>Hızlı Şablonlar (Hazır İstekler)</label>
            <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
              {PRESETS.map((preset, i) => (
                <button
                  key={i}
                  onClick={() => applyPreset(preset)}
                  title={preset.description}
                  style={{
                    padding: '6px 12px',
                    borderRadius: '6px',
                    background: 'rgba(255,255,255,0.04)',
                    border: '1px solid rgba(255,255,255,0.08)',
                    color: '#E5E7EB',
                    fontSize: '11px',
                    cursor: 'pointer',
                    fontWeight: 500,
                    transition: 'all 0.15s'
                  }}
                  onMouseEnter={e => { e.target.style.background = 'rgba(255,255,255,0.1)'; e.target.style.borderColor = 'rgba(59,130,246,0.3)'; }}
                  onMouseLeave={e => { e.target.style.background = 'rgba(255,255,255,0.04)'; e.target.style.borderColor = 'rgba(255,255,255,0.08)'; }}
                >
                  {preset.name}
                </button>
              ))}
            </div>
          </div>

          {/* İstek Satırı */}
          <div style={{ display: 'flex', gap: '8px' }}>
            <select
              value={method}
              onChange={e => setMethod(e.target.value)}
              style={{
                width: '100px',
                padding: '10px',
                background: 'rgba(26,26,36,0.6)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '8px',
                color: '#FFFFFF',
                fontWeight: 'bold',
                outline: 'none'
              }}
            >
              <option value="GET">GET</option>
              <option value="POST">POST</option>
              <option value="PUT">PUT</option>
              <option value="DELETE">DELETE</option>
            </select>

            <input
              type="text"
              placeholder="/api/health"
              value={endpoint}
              onChange={e => setEndpoint(e.target.value)}
              style={{
                flex: 1,
                padding: '10px 14px',
                background: 'rgba(26,26,36,0.6)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '8px',
                color: '#FFFFFF',
                outline: 'none'
              }}
            />
          </div>

          {/* X-API-Key Girişi */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <label style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: 500 }}>
              X-API-Key Başlığı (Header)
            </label>
            <input
              type="text"
              placeholder="tcp_..."
              value={apiKey}
              onChange={e => setApiKey(e.target.value)}
              style={{
                padding: '10px 14px',
                background: 'rgba(26,26,36,0.6)',
                border: '1px solid rgba(255,255,255,0.08)',
                borderRadius: '8px',
                color: '#60A5FA',
                fontFamily: 'monospace',
                fontSize: '13px',
                outline: 'none'
              }}
            />
          </div>

          {/* Request Body (POST/PUT için) */}
          {['POST', 'PUT', 'PATCH'].includes(method) && (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '6px', flex: 1 }}>
              <label style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: 500 }}>
                JSON İstek Gövdesi (Request Body)
              </label>
              <textarea
                rows={6}
                placeholder={`{\n  "key": "value"\n}`}
                value={requestBody}
                onChange={e => setRequestBody(e.target.value)}
                style={{
                  width: '100%',
                  padding: '12px',
                  background: 'rgba(26,26,36,0.6)',
                  border: '1px solid rgba(255,255,255,0.08)',
                  borderRadius: '8px',
                  color: '#34D399',
                  fontFamily: 'monospace',
                  fontSize: '13px',
                  outline: 'none',
                  resize: 'vertical',
                  boxSizing: 'border-box'
                }}
              />
            </div>
          )}

          <button
            onClick={handleSend}
            disabled={loading}
            style={{
              padding: '12px',
              background: loading ? 'rgba(16,185,129,0.2)' : 'linear-gradient(135deg, #10B981, #059669)',
              color: '#FFFFFF',
              border: 'none',
              borderRadius: '8px',
              fontWeight: 'bold',
              cursor: loading ? 'not-allowed' : 'pointer',
              transition: 'all 0.2s',
              boxShadow: '0 4px 12px rgba(16,185,129,0.2)'
            }}
          >
            {loading ? '⚡ Gönderiliyor...' : '🚀 İstek Gönder'}
          </button>
        </div>

        {/* SAĞ TARAF: Yanıt Önizleme */}
        <div style={{ flex: 1.2, background: 'rgba(17,17,24,0.6)', border: '1px solid rgba(255,255,255,0.06)', borderRadius: '14px', padding: '20px', display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <h4 style={{ margin: 0, color: '#FFFFFF', fontSize: '15px', fontWeight: 600, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>💻 Sunucu Yanıtı (Response)</span>
            {responseTime !== null && (
              <span style={{ fontSize: '11px', color: '#9CA3AF', fontWeight: 'normal', float: 'right' }}>
                ⏱️ {responseTime} ms
              </span>
            )}
          </h4>

          {!response ? (
            <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: '#6B7280', minHeight: '300px' }}>
              <span style={{ fontSize: '48px', marginBottom: '12px' }}>📥</span>
              <div>Henüz istek gönderilmedi</div>
              <div style={{ fontSize: '11px', marginTop: '4px' }}>Soldaki panelden parametreleri ayarlayıp isteği tetikleyin.</div>
            </div>
          ) : (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', flex: 1 }}>

              {/* Status & Code */}
              <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span style={{ fontSize: '13px', color: '#9CA3AF', fontWeight: 500 }}>Durum:</span>
                <span
                  style={{
                    padding: '4px 10px',
                    borderRadius: '6px',
                    fontSize: '12px',
                    fontWeight: 'bold',
                    background: response.status >= 200 && response.status < 300 ? 'rgba(16,185,129,0.12)' : 'rgba(239,68,68,0.12)',
                    color: response.status >= 200 && response.status < 300 ? '#34D399' : '#FCA5A5',
                    border: response.status >= 200 && response.status < 300 ? '1px solid rgba(16,185,129,0.2)' : '1px solid rgba(239,68,68,0.2)'
                  }}
                >
                  {response.status} {response.statusText}
                </span>
              </div>

              {/* Response Data (JSON block) */}
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column', gap: '6px' }}>
                <label style={{ fontSize: '12px', color: '#9CA3AF', fontWeight: 500 }}>Yanıt Gövdesi (Response Body)</label>
                <pre
                  style={{
                    margin: 0,
                    padding: '14px',
                    background: 'rgba(10,10,15,0.8)',
                    border: '1px solid rgba(255,255,255,0.06)',
                    borderRadius: '8px',
                    color: response.status >= 200 && response.status < 300 ? '#A7F3D0' : '#FECACA',
                    fontFamily: 'monospace',
                    fontSize: '13px',
                    overflow: 'auto',
                    maxHeight: '400px',
                    boxSizing: 'border-box'
                  }}
                >
                  {JSON.stringify(response.data, null, 2)}
                </pre>
              </div>
            </div>
          )}
        </div>
      </div>

    </div>
  );
}

export default ApiTesterTab;
